import { useAuth } from "./useAuth";

export function useShopRole() {
  const { hasRole, isPtaAdmin } = useAuth();
  
  const isShopRole = hasRole('shop');
  const isSiteAdmin = hasRole('site_admin');
  const hasShopAccess = isShopRole || isPtaAdmin || isSiteAdmin;

  return {
    isShopRole,
    hasShopAccess
  };
}
